import React from 'react';
import { Label as UiLabel, LabelProps } from '@make-software/cspr-design';

export const Label = (props: Omit<LabelProps, 'size'>) => (
  <UiLabel size={2} lineHeight={'xxs'} {...props} />
);
